export enum FlyoutProductCreationFaqSection {
  // Product Details page
  PRODUCT_DETAILS_PRODUCT_DETAILS = 'productDetails.productDetails',
  PRODUCT_DETAILS_SUPPORT_INFORMATION = 'productDetails.supportInformation',
  PRODUCT_DETAILS_PRODUCT_DISCOVERABILITY = 'productDetails.productDiscoverability',
  PRODUCT_DETAILS_EULA = 'productDetails.eula',
  PRODUCT_DETAILS_REFUND_POLICY = 'productDetails.refundPolicy',
  PRODUCT_DETAILS_ALLOW_LIST = 'productDetails.allowList',
  PRODUCT_DETAILS_ACKNOWLEDGMENT = 'productDetails.acknowledgment',

  // Product Dimensions page
  PRODUCT_DIMENSIONS_PURCHASING_OPTIONS = 'productDimensions.purchasingOptions',
  PRODUCT_DIMENSIONS_CONTRACT_DIMENSIONS = 'productDimensions.contractDimensions',

  // Buyer registration page
  BUYER_REGISTRATION_BRANDING = 'buyerRegistration.branding',
  BUYER_REGISTRATION_CONFIGURATION = 'buyerRegistration.configuration',
  BUYER_REGISTRATION_FORM_FIELDS = 'buyerRegistration.formFields',
  BUYER_REGISTRATION_REDIRECTION_SETTINGS = 'buyerRegistration.redirectionSettings',
  BUYER_REGISTRATION_PAGE_PREVIEW = 'buyerRegistration.pagePreview',
  // Notifications page
  NOTIFICATIONS_BUYER_NOTIFICATIONS = 'notifications.buyerNotifications',
  NOTIFICATIONS_LISTING_NOTIFICATIONS = 'notifications.listingNotifications',
  NOTIFICATIONS_PRIVATE_OFFER_PLATFORM_NOTIFICATIONS = 'notifications.privateOfferPlatformNotifications',
  NOTIFICATIONS_METERING_NOTIFICATIONS = 'notifications.meteringNotifications',
  NOTIFICATIONS_RESALE_AUTHORIZATION_NOTIFICATIONS = 'notifications.resaleAuthorizationNotifications',
}

export interface HelpDrawerFaqItems {
  question: JSX.Element
  answer: JSX.Element
}

export interface FlyoutProductCreationFaqItems {
  section: FlyoutProductCreationFaqSection
  faqItems: HelpDrawerFaqItems[]
}

// can move this to common components if required.
// But not sure how many new versions of help drawer we are going to create
export const FaqQuestion = ({
  section,
  question,
}: {
  section?: FlyoutProductCreationFaqSection | string
  question: string
}) => {
  return (
    <div data-testid={`faq-question-${section}`} className="faqQuestionV3">
      {question}
    </div>
  )
}
